import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "Store/configureStore";

export const themeStateSelector = (state: RootState) => state.theme;

export const themeDataSelector = createSelector(
  themeStateSelector,
  themeState => themeState.data
);

export const themeErrorsSelector = createSelector(
  themeStateSelector,
  themeState => themeState.errors
);
